import { useState } from "react";

import Arrow from "../img/arrow_back.svg";
import ArrowSelect from "../img/arrow_selector.svg";

import Close from "../img/close_multi.svg";

import "./style.scss";

const SelectingOptions = ({ mobile = false, item, formTemplateAnswerState, limit, handleClickExit, stateAnswer, handleStepBack, dataItemConnect, formTemplate, isDot = true }) => {
    const [radio, setRadio] = useState(false);
    const [checked, setChecked] = useState([]);
    const [checkedSelect, setCheckedSelect] = useState([]);
    const [open, setOpen] = useState(false);

    const handleChecked = (value) => {
        let add = checked.some((it) => it.text === value.text);
        if (add) {
            setChecked(checked.filter((el) => el.text !== value.text));
        } else {
            setChecked((prev) => prev.concat(value));
        }
    };

    const handleCheckedSelect = (value) => {
        let add = checkedSelect.some((it) => it.text === value.text);
        if (add) {
            setCheckedSelect(checkedSelect.filter((el) => el.text !== value.text));
        } else {
            setCheckedSelect((prev) => prev.concat(value));
        }
    };

    const handleClickRadio = () => {
        let obj = item.options.find((el) => el.text === radio);
        formTemplateAnswerState(obj, false, item);
    };

    const handleDelete = (e, elem) => {
        e.preventDefault();
        e.stopPropagation();
        let newArr = checkedSelect.filter((el) => el !== elem);
        setCheckedSelect(newArr);
    };

    const layout = (layout, array, item) => {
        switch (layout) {
            case "buttons":
                return (
                    <>
                        <div className={`selecting__options_answers ${item.typeQuestions} ${array.length === 2 ? "flex" : ""}`}>
                            {(stateAnswer && !limit) || (dataItemConnect && !limit) ? (
                                <div
                                    className="button__back"
                                    onClick={() =>
                                        handleStepBack(
                                            item,
                                            array.some((el) => el.relaitedId),
                                        )
                                    }
                                >
                                    <img src={Arrow} width={18} height={18} />
                                </div>
                            ) : null}
                            {array.map((el, index) => (
                                <div className={`button ${array.length === 2 ? "flex" : ""}`} key={index} onClick={() => formTemplateAnswerState(el, false, item)}>
                                    {el.text}
                                </div>
                            ))}
                        </div>
                        {/* {(stateAnswer && !limit) || (dataItemConnect && !limit) ? (
                                <div className="button__back" onClick={() => handleStepBack(item, array.some((el) => el.relaitedId))}>
                                    <img src={Arrow} width={18} height={18} />
                                </div>
                            ) : null} */}
                    </>
                );

            case "radioButtons":
                return (
                    <div className={`selecting__options_answers ${item.typeQuestions}`}>
                        {array.map((el, index) => (
                            <div className="radio" key={index}>
                                <input type="radio" value={el.text} checked={radio === el.text} onChange={(e) => setRadio(e.target.value)} />
                                <label className="label">{el.text}</label>
                            </div>
                        ))}
                        {radio ? (
                            <div className={`selecting__options_button`} onClick={() => handleClickRadio()}>
                                Выбрать
                            </div>
                        ) : null}

                        {(stateAnswer && !limit) || (dataItemConnect && !limit) ? (
                            <div
                                className="button__back"
                                onClick={() =>
                                    handleStepBack(
                                        item,
                                        array.some((el) => el.relaitedId),
                                    )
                                }
                                style={{ width: "100%" }}
                            >
                                <img src={Arrow} width={18} height={18} />
                            </div>
                        ) : null}
                    </div>
                );

            case "checkbox":
                return (
                    <div className={`selecting__options_answers ${item.typeQuestions}`}>
                        {array.map((el, index) => (
                            <div className="checklist" key={index}>
                                <div className={`checklist__checkbox  ${checked.find((it) => it.text === el.text) ? `checked` : ""}`} onClick={() => handleChecked(el)}></div>
                                <label className="label">{el.text}</label>
                            </div>
                        ))}

                        {checked.length ? (
                            <div className={`selecting__options_button ${checked.length ? "vizible" : ""}`} onClick={() => formTemplateAnswerState(checked, "select", item)}>
                                Выбрать
                            </div>
                        ) : null}

                        {(stateAnswer && !limit) || (dataItemConnect && !limit) ? (
                            <div
                                className="button__back"
                                onClick={() =>
                                    handleStepBack(
                                        item,
                                        array.some((el) => el.relaitedId),
                                    )
                                }
                                style={{ width: "100%" }}
                            >
                                <img src={Arrow} width={18} height={18} />
                            </div>
                        ) : null}
                    </div>
                );

            case "selectSuggest":
                return (
                    <div className={`selecting__options_answers ${item.typeQuestions}`} key={item._id}>
                        <div className={`select ${checkedSelect.length ? "multi" : ""}`} onClick={() => setOpen(!open)}>
                            {checkedSelect.length ? (
                                checkedSelect.map((el, index) => (
                                    <div className="multi__el" key={index} onClick={() => setOpen(!open)}>
                                        <img src={Close} onClick={(e) => handleDelete(e, el)} />
                                        <span>{el.text}</span>
                                    </div>
                                ))
                            ) : (
                                <div className="select__block" onClick={() => setOpen(!open)}>
                                    <span className="selsect__title">Выберите ответ</span>
                                    <img src={ArrowSelect} />
                                </div>
                            )}
                        </div>
                        <div className={`select__list ${open ? "select__list_open" : ""}`}>
                            <div className="select__list-content">
                                {array.map((el, index) => (
                                    <div className="checklist" key={index} onClick={() => handleCheckedSelect(el)}>
                                        <div className={`checklist__checkbox ${checkedSelect.find((it) => it.text === el.text) ? "checked" : ""}`}></div>
                                        <label className="label">{el.text}</label>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {checkedSelect.length ? (
                            <div
                                className={`selecting__options_button ${checkedSelect.length ? "vizible" : ""}`}
                                onClick={() => {
                                    formTemplateAnswerState(checkedSelect, "select", item);
                                    setOpen(false);
                                    setCheckedSelect([]);
                                }}
                            >
                                Выбрать
                            </div>
                        ) : null}

                        {stateAnswer || dataItemConnect ? (
                            <div
                                className="button__back"
                                onClick={() =>
                                    handleStepBack(
                                        item,
                                        array.some((el) => el.relaitedId),
                                    )
                                }
                                style={{ width: "100%" }}
                            >
                                <img src={Arrow} width={18} height={18} />
                            </div>
                        ) : null}
                    </div>
                );
        }
    };

    return (
        <div className="selecting__options">
            <div className="selecting__exit">
                <div className="title">{!limit ? item?.question : limit.isLimitText ? limit.isLimitText : `Вам не подходит`}</div>
                {limit ? (
                    <div className={`selecting__options_button`} onClick={() => handleClickExit()}>
                        {limit.isLimitButtonText}
                    </div>
                ) : null}
            </div>

            {!limit ? (
                <>
                    {layout(item?.typeQuestions, item?.options, item)}

                    {isDot && formTemplate.length > 1 ? (
                        <div className="selecting__progress">
                            {formTemplate.map((q, idx) => (
                                <div key={q._id || idx} className={`dot ${idx + 1 === item.lvl ? "dot_active" : ""}`} />
                            ))}
                        </div>
                    ) : null}
                </>
            ) : null}
        </div>
    );
};

export default SelectingOptions;
